export default __webpack_public_path__ + "static/media/placeholder_dummy2016-asia-restaurant01-de.d66543f3.png";